module.exports = __webpack_public_path__ + "static/media/dep-notarize.b5a3e204.png";